import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";
import PatchListModalDialog from "../../patchlists_modaldialog.js";

export default class PagePatch
{
    constructor(targetElement)
    {
        this.patchListModal = new PatchListModalDialog();
        const projectId = targetElement.dataset.projectid;
        const sandboxurl = targetElement.dataset.sandboxurl;

        this.patch = null;
        this.prevStyleWidth = "";
        this.prevStyleHeight = "";
        this.maximized = false;
        this.oldClasses = [];
        this.projectId = projectId;

        web.embedPatch(
            {
                "elementId": "canvascontainer",
                "projectId": projectId,
                "sandboxUrl": sandboxurl,
                "locationHash": window.location.hash,
                "queryString": window.location.search
            }, (error) =>
            {
                const errorEl = document.getElementById("errorEl");
                const canvasContainer = document.getElementById("canvascontainer");
                if (canvasContainer) canvasContainer.style.display = "none";
                if (errorEl)
                {
                    errorEl.style.display = "block";
                    const msg = errorEl.querySelector(".errorMessage");
                    msg.innerText = error.msg;
                }
            });

        this.resize();
        this.getProjectComments(projectId, web.env.loggedIn);
        // this.disableIframeScrolling();
        web.favs.showFavToggle(ele.byId("toggleFav"));

        window.addEventListener("resize", this.resize.bind(this), false);

        window.addEventListener("message", (event) =>
        {
            if (event.origin !== sandboxurl) return;
            if (event.data && event.data.type === "hashchange")
            {
                window.location.hash = event.data.data;
            }
        }, false);

        window.addEventListener("hashchange", (event) =>
        {
            const patchIframe = document.getElementById("canvasiframe");
            if (patchIframe)
            {
                const srcParts = patchIframe.src.split("#", 2);
                const newUrl = srcParts[0] + window.location.hash;
                patchIframe.contentWindow.location.replace(newUrl);
            }
        }, false);

        let iframeFocus = false;

        const modalBgEle = document.createElement("div");
        modalBgEle.style.width = "100vw";
        modalBgEle.style.height = "100vh";
        modalBgEle.style.top = "0px";
        modalBgEle.style.left = "0px";
        modalBgEle.style.pointerEvents = "none";
        modalBgEle.style.zIndex = "1000";
        modalBgEle.style.position = "absolute";
        modalBgEle.style.display = "none";
        modalBgEle.style.backgroundColor = "rgba(0,0,0,0.5)";
        document.body.appendChild(modalBgEle);

        const iframe = ele.byId("canvasiframe");
        setInterval(() =>
        {
            if (document.activeElement == iframe)
            {
                if (!iframeFocus)
                {
                    iframeFocus = true;
                    document.body.style.overflowY = "scroll";
                    document.body.style.position = "fixed";
                    document.body.style.width = "100%";
                    iframe.style.zIndex = 1001;
                    iframe.style.position = "absolute";

                    modalBgEle.style.display = "block";
                }
            }
            else
            {
                if (iframeFocus)
                {
                    iframeFocus = false;

                    iframe.style.zIndex = "initial";

                    iframe.style.position = "initial";
                    document.body.style.overflowY = "initial";
                    document.body.style.position = "initial";
                    document.body.style.width = "auto";

                    modalBgEle.style.display = "none";
                }
            }
        }, 50);
    }

    showError(txt)
    {
        document.getElementById("glcanvas").remove();

        let newDiv = document.createElement("div");
        newDiv.setAttribute("class", "error");
        newDiv.innerText = txt;

        document.body.appendChild(newDiv);
        this.canceled = true;
    }

    resize()
    {
        let m = document.getElementById("canvasiframe");
        let c = document.getElementById("canvascontainer");
        let w = c.offsetWidth;

        let h = w * 9 / 16;
        if (document.body.clientHeight > document.body.clientWidth)
        {
            // mobile
            h = c.clientHeight;
        }

        if (m)m.style.width = w + "px";
        if (m)m.style.height = h + "px";
        if (c)c.style.height = h + "px";
    }

    requestPatchAccess(projectId, permission = "read")
    {
        web.projects.requestAccess(projectId, permission, (result) =>
        {
            ele.hide(ele.byId("request-access-button"));
            ele.show(ele.byId("request-pending-text"));
        });
    }

    getProjectComments(projectId)
    {
        api.get("comments/" + projectId, (result) =>
        {
            let html = "";
            result.reverse();
            for (const i in result)
            {
                html += web.getHandleBarHtml("comment", result[i]);
            }

            ele.byId("project_comments").innerHTML = html;
            web.buttons.stopSavingAnimButton();
        });
    }

    comment(projectId)
    {
        if (ele.byQuery(".comment_content textarea").value === "") return web.buttons.stopSavingAnimButton();
        api.post(
            "comment/" + projectId,
            { "content": ele.byQuery(".comment_content textarea").value },
            (res) =>
            {
                this.getProjectComments(projectId, true);
            }
        );
    }

    showMaximized(id)
    {
        let elIframe = document.getElementById(id);
        let elContain = document.getElementById("canvascontainer");

        this.maximized = !this.maximized;

        if (!this.maximized)
        {
            elContain.parentElement.parentElement.classList.add("row");
            elContain.style.width = this.prevStyleWidth;
            elContain.style.height = this.prevStyleHeight;

            for (let i = 0; i < this.oldClasses.length; i++)
            {
                elContain.parentElement.classList.add(this.oldClasses[i]);
            }
            this.oldClasses.length = 0;

            elIframe.style = "";
            elIframe.style.height = "100%";
            return;
        }
        else
        {
            elContain.parentElement.parentElement.classList.remove("row");

            this.prevStyleWidth = elContain.style.width;
            this.prevStyleHeight = elContain.style.height;

            elContain.style = "";

            const classList = elContain.parentElement.classList;
            while (classList.length > 0)
            {
                this.oldClasses.push(classList.item(0));
                classList.remove(classList.item(0));
            }
        }

        let newHeight = window.innerHeight * 0.85;
        let newWidth = newHeight * 16 / 9;

        if (newWidth > document.body.scrollWidth)
        {
            newWidth = document.body.scrollWidth;
            newHeight = newWidth * 9 / 16;
        }

        elIframe.style.height = newHeight + "px";
        elIframe.style.width = newWidth + "px";
        elIframe.style["margin-left"] = (document.body.scrollWidth - newWidth) / 2 + "px";

        if (window.resizeListenwerAdded) return;
        window.resizeListenwerAdded = true;
        window.addEventListener("resize", () =>
        {
            if (!this.maximized) return;
            this.showMaximized(id);
        });
    }

    showFullscreen(id)
    {
        let element = document.getElementById(id);
        if (!element) return;

        if (element.requestFullScreen)
        {
            element.requestFullScreen();
        }
        else if (element.mozRequestFullScreen)
        {
            element.mozRequestFullScreen();
        }
        else if (element.webkitRequestFullScreen)
        {
            element.webkitRequestFullScreen();
        }
        else
        {
            element.classList.add("fakefullscreen");
            document.body.styleoverflow = "none";
        }
    }

    genQrCode()
    {
        const qrcanvas = document.getElementById("qrcanvas");
        qrcanvas.innerText = "";

        new QRCode(document.getElementById("qrcanvas"), {
            "text": document.location.href,
            "width": 150,
            "height": 150,
            "colorDark": "#000000",
            "colorLight": "#ffffff",
            "correctLevel": QRCode.CorrectLevel.H
        });
    }

    leaveProject(id, uid)
    {
        api.delete("project/" + id + "/user/" + uid, {}, () =>
        {
            document.location.reload();
        });
    }
}
